import React, { useEffect } from 'react';
import { App as MyApp, Spin, Watermark } from 'antd';
import { MainPage } from '../MainPage/MainPage';
import { authService } from '../../../../api/authService/authService';
import { useAppDispatch, useAppSelector } from '../../../../core/redux';
import { authorizationSlice } from '../../../authorization/AuthorizationSlice';
const { setIsAuth } = authorizationSlice.actions;
import { projectsApiService } from '../../../../api/projects/projectsApiService';
import logo from '../../../../assets/images/superset-logo@2x.png';
import Types from '../../../../../types/types';
import { appSlice } from '../../AppSlice';

import s from './App.module.scss';
import { Auth } from '../../../authorization/Auth/Auth';

const Error: React.FC = () => (
  <Watermark content={['Нэтрика', 'Экстрактор CDA']} image={logo}>
    <div className={s.Error}>
      <div className={s.message}>Не удалось связаться с сервером</div>
    </div>
  </Watermark>
);

const { appSizesMap } = Types;

const { setAppSize } = appSlice.actions;
export const App = () => {
  const dispatch = useAppDispatch();
  const {
    data,
    // isError: dataIsError,
    // error: dataError,
    // status: dataStatus,
    isLoading: dataIsLoading,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } = authService.useGetOAuth2Query();

  const [
    getAllProjects,
    {
      data: projectsData,
      // isError: projectsIsError,
      error: projectsError,
      // status: projectsStatus,
      isLoading: projectsLoading,
    },
  ] = projectsApiService.useGetProjectsMutation();

  const { isAuth = false } = useAppSelector((state) => state.authorizationReducer);

  if (process.env?.REACT_APP_OAUTH2 === 'false') {
    return (
      <MyApp>
        <div className={s.App}>{isAuth ? <MainPage /> : <Auth />}</div>
      </MyApp>
    );
  }

  useEffect(() => {
    getAllProjects({ skip: 0, limit: 1000 });
  }, [isAuth]);

  useEffect(() => {
    if (!isAuth && !projectsError && !projectsLoading && projectsData) {
      dispatch(setIsAuth(true));

      return;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (projectsError?.data?.detail === 'Unauthorized' && data) {
      const url = data.authorization_url;
      window.open(url, '_self');
      return;
    }
  }, [projectsError, projectsLoading, projectsData, isAuth]);

  useEffect(() => {
    const getSizeKey = () => {
      const size = document.documentElement.clientWidth;
      if (size < appSizesMap.get('mobile').size) return appSizesMap.get('plug').key;
      if (size >= appSizesMap.get('large').size) return appSizesMap.get('large').key;
      if (size >= appSizesMap.get('desktop').size) return appSizesMap.get('desktop').key;
      if (size >= appSizesMap.get('tablet').size) return appSizesMap.get('tablet').key;
      if (size < appSizesMap.get('tablet').size) return appSizesMap.get('mobile').key;
      return appSizesMap.get('desktop').key;
    };

    const onResize = () => {
      const sizeKey = getSizeKey();
      dispatch(setAppSize(sizeKey));
    };

    onResize();
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, [dispatch]);

  const renderLoader = () => {
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spin tip='Загрузка...' spinning={true} size='large'></Spin>
      </div>
    );
  };
  if (!isAuth) {
    return (
      <MyApp>
        <div className={s.App}>{!data && !dataIsLoading ? <Error /> : renderLoader()}</div>
      </MyApp>
    );
  }

  return (
    <MyApp>
      <div className={s.App}>{<MainPage />}</div>
    </MyApp>
  );
};
